function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "url(#messenger_svg__paint0_radial_427_109503)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.05 9.214c-6.105 0-10.84 4.474-10.84 10.515 0 3.16 1.296 5.891 3.405 7.777.176.158.284.38.29.618l.06 1.93a.867.867 0 001.216.767l2.152-.949a.871.871 0 01.58-.043c.989.271 2.04.417 3.138.417 6.106 0 10.84-4.474 10.84-10.514 0-6.041-4.734-10.518-10.84-10.518z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.541 22.805l3.185-5.052a1.626 1.626 0 012.352-.433l2.534 1.9a.65.65 0 00.783-.003l3.42-2.596c.455-.347 1.051.2.748.685l-3.187 5.049a1.627 1.627 0 01-2.352.433l-2.534-1.9a.65.65 0 00-.783.003l-3.42 2.597c-.456.346-1.052-.198-.746-.683z",
  fill: "url(#messenger_svg__paint1_radial_427_109503)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "messenger_svg__paint0_radial_427_109503",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(44 0 0 43.9988 6.7 39.999)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#09F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#A033FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#FF5280"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7061"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "messenger_svg__paint1_radial_427_109503",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.842 30.894) scale(23.8479)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#09F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#A033FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#FF5280"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7061"
})));

function SvgMessenger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgMessenger;